export default __webpack_public_path__ + "static/media/intro-fleet.6883a2f7.png";